import get from 'lodash.get'

const pkg = state => state.pkg
const app = state => state.app
const device = state => state.app.device
const sidebar = state => state.app.sidebar
const effect = state => state.app.effect
const menuitems = state => state.menu.items
const authorizedmenuitems = state => state.menu.authorizedItems
const componententry = state => state.menu.authorizedItems.filter(c => c.meta && c.meta.label === 'Components')[0]
const username = state => state.user.name
const user = state => state.user
const subscription = state => state.subscription
const planPrices = state => state.planPrices
const projectsCount = state => state.projectsCount
const projectTypes = state => {
  let projectTypes = state.projectTypes.slice()

  if (state.user.is_admin) {
    return projectTypes
  }

  let authorizedProjectTypes = []

  if (get(state.user, 'allowed_systems.backlink_sites')) {
    authorizedProjectTypes.push('basic', 'private')
  }

  if (get(state.user, 'allowed_systems.business_sites')) {
    authorizedProjectTypes.push('business')
  }

  return authorizedProjectTypes
}

export {
  pkg,
  app,
  device,
  sidebar,
  effect,
  menuitems,
  authorizedmenuitems,
  componententry,
  username,
  user,
  subscription,
  planPrices,
  projectTypes,
  projectsCount
}
